import Vue from 'vue'
import Vuex from 'vuex'
import mobileDetect from './modules/mobileDetect'
import weatherStation from './modules/weatherStation'
import trafficVD from './modules/trafficVD'
import trafficCCTV from './modules/trafficCCTV'
import elasticSearch from './modules/elasticSearch'
import eastCoastDataApi from './modules/eastCoastDataApi'
import eastCoastMonitor from './modules/eastCoastMonitor'
import adminDist from './modules/adminDist'
// import toiletMgt from './modules/adminDist/ToiletMgt'
// import violation from './modules/adminDist/violation'
// import StayAverage from './modules/adminDist/StayAverage'
import CONST from '../utils/const'
import Utils from '../utils/utils'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		name: '',
		pictureUrl: 'assets/images/!logged-user.jpg',
		systemName: '',
		operations: [],
		config: null,
	},
	modules: {
		mobileDetect,
		weatherStation,
		trafficVD,
		trafficCCTV,
		elasticSearch,
		eastCoastDataApi,
		eastCoastMonitor,
		adminDist,
	},
	getters: {
		getScenicAreaVideoCamera(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA
			})
		},

		getScenicAreaHandsanitizer(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.HAND_SANITIZER_DETECTOR
			})
		},

		getScenicAreaPeculiarSmell(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.PECULIAR_SMELL_DETETOR
			})
		},

		getScenicAreaVehicleVideoCamera(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA && (
					device.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.VEHICLE_IN || device.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.VEHICLE_OUT
					)
			})
		},

		getScenicAreaVehicleInCamera(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA && 
					device.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.VEHICLE_IN
			})
		},

		getScenicAreaToiletPeopleFlowVideoCamera(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA && device.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.TOILET_PERSON_FLOW
			})
		},

		getScenicAreaCenterPeopleFlowVideoCamera(state, getters) {
			if (Utils.isEmptyObject(state.eastCoastDataApi.scenicArea.scenicAreaDevice)) {
				return []
			}

			return state.eastCoastDataApi.scenicArea.scenicAreaDevice.filter(device => {
				return device.operationType === CONST.EAST_COAST_DEVICE_TYPE.VIDEO_CAMERA && device.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.CENTER_PEOPLE_PERSONFLOW
			})
		}
	},
	mutations: {
		name(state, value) {
			state.name = value;
		},
		pictureUrl(state, value) {
			state.pictureUrl = value;
		},
		systemName(state, value) {
			state.systemName = value;
		},
		operations(state, value) {
			state.operations = value;
		},
		setConfig(state, data) {
			state.config = data
		},
	},
	actions: {
		async getConfigData({ commit }) {
			const config = await fetch('/config.json').then(resp => resp.json())
			commit('setConfig', config)
		}
	}
})